module.exports = __webpack_public_path__ + "img/ship.f81924f6.svg";